export default __webpack_public_path__ + "static/media/icons8-microsoft-access.67b2fc5f.svg";